<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
<v-flex pa-1 xs12 sm12 md12>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
              <v-layout wrap>
                <div class="flex md12">
                  <div v-show="codegorunum === true ">
                    <v-text-field label="Döviz Kodu" :color="color" v-model="Doviz.DovizKod" :error-messages="errors.collect('name')"
                      v-validate="'required'" data-vv-name="name" required>
                    </v-text-field>
                  </div>

                  <v-text-field label="Döviz Adı" :color="color" v-model="Doviz.DovizAdi" :error-messages="errors.collect('name1')"
                    v-validate="'required'" data-vv-name="name1" required>
                  </v-text-field>
                </div>
              </v-layout>
  </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
              <v-btn id="bsil" color="blue darken-1" flat @click="deletedoviz()">Sil</v-btn>
            </div>
            <div v-show="k === true">
              <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
            </div>
            <v-btn color="blue darken-1" flat @click.native="dialog = false">Vazgeç</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>Döviz</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
        <v-btn flat @click="dovizekle()"> Döviz Ekle
          <v-icon right dark>add_box</v-icon>
        </v-btn>
        <v-menu offset-y>
          <v-btn slot="activator" dark icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click.native="dialogdoviz = true">
              <v-list-tile-title>Döviz Aktar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-layout>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items" :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.DovizKod)" item>
            <td class="text-xs-left">{{ props.item.DovizAdi }}</td>
            <td class="text-xs-left">{{ props.item.DovizKod }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
        </v-alert>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogdoviz" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Uyarı!</v-card-title>
        <v-card-text> Arkman serverlarında yer alan standart döviz bilgileri, otomatik olarak sisteme aktarılacaktır.
          Kayıtlı olan döviz bilgileri aktarılmayacaktır.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange darken-3" flat="flat" @click.native="dialogdoviz = false">İptal</v-btn>
          <v-btn color="orange darken-3" flat @click.native="aktar()">Tamam</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        headers: [{
            text: 'Döviz Adı',
            value: 'DovizAdi'
          },
          {
            text: 'Döviz Kodu',
            value: 'DovizKod'
          }
        ],
        items: [],
        search3: '',
        selected: '',
        m: false,
        k: false,
        dialog: false,
        dialogdoviz: false,
        color: 'orange darken-4',
        progress: false,
        Doviz: {
          DovizAdi: '',
          DovizKod: '',
          EkranNo: ''
        },
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        name: '',
        name1: '',
        dictionary: {
          custom: {
            name: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            name1: {
              required: () => 'Bu alan boş bırakılamaz',
            }
          }
        }
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Döviz Güncelle'
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          CompanyCode: credentials.SirketKodu,
          CurrencyCode: v
        }

        this.$http.post(auth.API_URL + 'api/currency/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Doviz = response.body[0]
        })
      },
      deletedoviz: deletedoviz,
      dovizekle: dovizekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      aktar: aktar
    },
    beforeMount: beforeMount,
  }

  function aktar() {
    this.$http.post(auth.API_URL + 'api/currency/Stream', {}, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      this.dialogdoviz = false


      this.$http.post(auth.API_URL + 'api/currency/List', {}, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.items = response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })



  }

  function Kaydet() {
    this.$validator.validateAll().then((result) => {

      if (result) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params1 = {
          CompanyCode: credentials.SirketKodu,
        }

        var params = {
          CompanyCode: credentials.SirketKodu,
          CurrencyCode: this.Doviz.DovizKod,
          CurrencyName: this.Doviz.DovizAdi
        }
        this.$http.post(auth.API_URL + 'api/currency/Add', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.$http.post(auth.API_URL + 'api/currency/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
              this.text1 = 'Kayıt işlemi tamamlandı.'
              this.snackbar = true
            }, (response) => {
              if (response.status === 0) {
                console.log('')
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }
    })
  }

  function dovizekle() {
    this.dialog = true
    this.Masrafmerkezi = {}
    this.$validator.reset()
    this.dialog_baslik = 'Döviz Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
  }

  function beforeMount() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params = {
      CompanyCode: credentials.SirketKodu,
    }

    this.progress = true
    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.progress = false
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }

  function deletedoviz() {
    if (window.confirm('Döviz\'i silmek istediğinizden eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));



      var params1 = {
        CompanyCode: credentials.SirketKodu,
      }

      var params = {
        CompanyCode: credentials.SirketKodu,
        CurrencyCode: this.Doviz.DovizKod,
        CurrencyName: this.Doviz.DovizAdi
      }
      this.$http.post(auth.API_URL + 'api/currency/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.$http.post(auth.API_URL + 'api/currency/List', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false
            this.text1 = 'Silme işlemi tamamlandı'
            this.snackbar = true
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = Response.body.statusText
              this.snackbar = true
            }
          })
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = Response.body.statusText
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {

      if (result) {


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params1 = {
          CompanyCode: credentials.SirketKodu,
        }


        var params = {
          CompanyCode: credentials.SirketKodu,
          CurrencyCode: this.Doviz.DovizKod,
          CurrencyName: this.Doviz.DovizAdi
        }
        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/currency/Update', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = 'Güncelleme işlemi tamamlandı'
            this.snackbar = true
            this.$http.post(auth.API_URL + 'api/currency/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>
<style>
</style>